// Campus photo for /colleges/fordham-university: CC BY-SA 4.0, by Indefatigable2, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AQueen's_Court_and_University_Church_at_Fordham.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/fordham-university/; credited under the photo.
const photo = {
    "slug": "fordham-university",
    "alt": "Queen's Court and the University Church on the Rose Hill campus of Fordham University in the Bronx, New York",
    "src": "/colleges/fordham-university/campus-1600.webp",
    "srcSmall": "/colleges/fordham-university/campus-800.webp",
    "srcMid": "/colleges/fordham-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/fordham-university/og.jpg",
    "title": "Queen's Court and University Church at Fordham",
    "author": "Indefatigable2",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AQueen's_Court_and_University_Church_at_Fordham.jpg",
    "read": "2026-10-02"
};

export default photo;
